import React from "react"
import styled from "styled-components"
// import LogoIcon from "../../../resources/img/logo-black.svg"
import LogoIcon from "../../../resources/img/logo-2025.svg"
import BlockContainer from "../BlockContainer"
import Search from "./icons/Search"
import BagLink from "./BagLink"
import Alink from "../Alink"
import breakpoints from "../../../styles/breakpoints"
import fonts from "../../../styles/fonts"
import colors from "../../../styles/colors"
// import Account from "./icons/Account"
import DesktopLink from "./DesktopLink"
import { getIsVisibleInLocale } from "../../../services/links"
import { useI18next } from "gatsby-plugin-react-i18next"
import { getIsFrance } from "../../../services/locale"

const HeaderContainer = styled.header`
  display: none;
  position: relative;

  @media (min-width: ${breakpoints.lg}) {
    display: block;
  }
`

const NavContent = styled.div`
  padding: 23px 0 0;
`

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  width: 100%;
  position: relative;
`

const LogoLink = styled(Alink)`
  display: flex;
`

const Logo = styled.img`
  width: 74px;
`

const Whatsapp = styled.a`
  ${fonts.ivyStyleLight};
  font-size: 10px;
  line-height: 1.75;
  display: flex;
  padding: 3px 8px;
  text-decoration: underline;
  background-color: ${colors.newbeige};
  /* background-color: #5a784f; */
  border-radius: 69.5px;
  color: ${colors.trueBlack};
  /* color: white; */
  position: absolute;
  left: 0%;
  top: 50%;
  transform: translateY(-50%);
  text-decoration-color: #00000080;
  text-underline-offset: 1px;

  &:hover {
    text-decoration: none;
  }
`

const LinkList = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
`

const Icons = styled.div`
  display: flex;
  gap: 16px;
  padding-bottom: 23px;
`

const SearchLink = styled(Alink)`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 14.5px;
    height: 14.5px;
  }
`

// const AccountButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: transparent;
//   padding: 0;
//   border: none;
//   cursor: pointer;
// `

const DesktopHeader = ({
  nav,
  activeTab,
  setActiveTab,
  cartOpen,
  setCartOpen,
  handleAccountClick,
}) => {
  const { t } = useI18next()

  const isFrance = getIsFrance()

  let activeEnv = process.env.GATSBY_ACTIVE_ENV

  const availableEnvironments = ["eu", "uk", "fr", "us"]

  if (!availableEnvironments.includes(activeEnv)) {
    activeEnv = "us"
  }

  const searchUrl = activeEnv === "us" ? "/search" : `/${activeEnv}/search`

  return (
    <HeaderContainer>
      <BlockContainer header={true}>
        <NavContent>
          <LogoContainer>
            <Whatsapp
              href={`${isFrance ? `https://api.whatsapp.com/send/?phone=%2B33623046861&text&type=phone_number&app_absent=0` : `https://wa.me/+447897789225`}`}
              target="_blank"
              rel="noreferrer noopener"
            >
              {t("header.whatsapp")}
            </Whatsapp>
            <LogoLink to="/">
              <Logo src={LogoIcon} alt="Kimaï" />
            </LogoLink>
          </LogoContainer>
          <LinkList>
            {nav.map((link, index) => {
              const visible = getIsVisibleInLocale(link.locale)

              if (!visible) return null

              return (
                <DesktopLink
                  link={link}
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                  key={index}
                />
              )
            })}
            <Icons>
              <SearchLink to={searchUrl} aria-label="Search" prefetch={false}>
                <Search />
              </SearchLink>
              {/* {!isFrance && (
                <AccountButton onClick={() => handleAccountClick()}>
                  <Account />
                </AccountButton>
              )} */}
              <BagLink cartOpen={cartOpen} setCartOpen={setCartOpen} />
            </Icons>
          </LinkList>
        </NavContent>
      </BlockContainer>
    </HeaderContainer>
  )
}

export default DesktopHeader
